import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { TokenRequestDto, TokenSocialRequestDto } from '../models/auth-models';
import { WebApiResponse } from '../../api/models/api-model';

@Injectable({
	providedIn: 'root'
})
export class AuthProxyService {

	constructor(private http: HttpClient) { }

	public tokenSocial(tokenRequestDto: TokenSocialRequestDto): Observable<WebApiResponse<TokenSocialRequestDto>> {
		const url = `${environment.api.fasttrackApi}/TokenAuth/ExternalAuthenticate`;
		return this.http.post<TokenSocialRequestDto>(url, tokenRequestDto).pipe(
			map(res => res as WebApiResponse<TokenSocialRequestDto>)
		);
	}

	public token(tokenRequestDto: TokenRequestDto): Observable<WebApiResponse<TokenRequestDto>> {
		const url = `${environment.api.fasttrackApi}/TokenAuth/Authenticate`;
		return this.http.post(url, tokenRequestDto).pipe(
			map(res => res as WebApiResponse<TokenRequestDto>)
		);
	}

	public refreshToken(tokenRequestDto: TokenRequestDto): Observable<WebApiResponse<TokenRequestDto>> {
		const url = `${environment.api.fasttrackApi}/TokenAuth/RefreshToken?refreshToken=${tokenRequestDto.refreshToken}`;
		return this.http.post(url, {}).pipe(
			map(res => res as WebApiResponse<TokenRequestDto>)
		);
	}

	public tokenLogout(): Observable<object> {
		const url = `${environment.api.fasttrackApi}/TokenAuth/LogOut`;
		return this.http.get(url);
	}
}
